import { Settings } from "lucide-react";

export const SettingsHeader = () => {
  return (
    <div className="flex items-center gap-4 mb-6">
      <Settings className="h-8 w-8 text-muted-foreground" />
      <h1 className="text-3xl font-bold">Paramètres</h1>
    </div>
  );
};